<input #fileInput type="file" [id]="fileInputId" (change)="onFileSelected($event)" [accept]="accept()" style="display: none" />
<p-button
  size="large"
  [label]="buttonLabel()"
  (click)="triggerFileInputClick(fileInput)"
  [loading]="isLoading()"
  [disabled]="disabled() || isLoading()"
  pTooltip="Un vídeo que muestre la imagen principal animada"></p-button>
